// @ts-nocheck
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
// import ProductAvailability, { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import React from "react";
import { connect } from "react-redux";

/* Store Custom Code - Start */
import ProductAvailability, {
    getStatusValue,
    ProductAvailabilityStyles,
} from "@store/Overrides/Components/ProductAvailability";
/* Store Custom Code - End */

interface OwnProps {
    isProductDetailsPage?: boolean;
    configurationCompleted?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    /* Store Custom Code - Start */
    const settings = getSettingsCollection(state);
    const rawStatuses = settings.productStatusSettings.notAllowedToAddToCart;
    const notAllowedToAddToCart = new Set(rawStatuses?.split(",").map(s => s.trim()));
    /* Store Custom Code - End */
    return {
        includeRealTimeInventoryAndPricingForSeo: settings.websiteSettings.includeRealTimeInventoryAndPricingForSeo, // Store Custom Code
        // Store Custom Code
        notAllowedToAddToCart,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProduct;

const ProductContextAvailability = ({
    includeRealTimeInventoryAndPricingForSeo,
    productInfo,
    product,
    isProductDetailsPage,
    configurationCompleted,
    extendedStyles,
    // Store Custom Code
    notAllowedToAddToCart,
}: Props) => {
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;
    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    if (
        (getIsWebCrawler() && !includeRealTimeInventoryAndPricingForSeo) ||
        product.isVariantParent ||
        (!!product.configurationType &&
            product.configurationType !== ConfigurationType.None &&
            product.configurationType !== ConfigurationType.Fixed &&
            !configurationCompleted)
    ) {
        return null;
    }
    /* Store Custom Code - Start */
    const status = getStatusValue(product);

    if (status && notAllowedToAddToCart?.has(status)) {
        return null;
    }
    /* Store Custom Code - End */

    return (
        <ProductAvailability
            productId={product.id}
            trackInventory={product.trackInventory}
            availability={availability}
            unitOfMeasure={unitOfMeasure}
            isProductDetailsPage={isProductDetailsPage}
            failedToLoadInventory={failedToLoadInventory}
            extendedStyles={extendedStyles}
            // Store Custom Code
            futureAvailability={inventory?.additionalResults?.futureAvailability || undefined}
        />
    );
};

export default connect(mapStateToProps)(withProduct(ProductContextAvailability));
